<template>
  <div class="uk-flex-center uk-margin-medium-top" uk-grid>
    <ErrorModal id="CreateTicketErrorModal" message="There was an error creating your support ticket. Please review your data and try again or contact support." />

    <div class="uk-width-1-2@l uk-width-1-1@s">
      <Card>
        <template v-slot:header>
            <h2>Create New Ticket</h2>
        </template>

        <template v-slot:body>
          <form class="uk-form uk-grid-row-small" uk-grid @submit.prevent="submit_create_ticket">

            <div class="uk-width-1-2">
              <label class="uk-form-label" for="summary">Department</label>
              <div class="uk-form-controls uk-margin-small-top">
                <select class="uk-select" type="text" name="department" v-model="ticket.department_id" required>
                  <option v-for="(department, index) in departments" :key="index" :value="department.id">{{ department.name.toLowerCase() }}</option>
                </select>
              </div>
            </div>

            <div class="uk-width-1-2">
              <label class="uk-form-label" for="summary">Priority</label>
              <div class="uk-form-controls uk-margin-small-top">
                <select class="uk-select" type="text" name="priority" v-model="ticket.priority" required>
                  <option v-for="(priority, index) in priorities" :key="index" :value="priority">{{ priority }}</option>
                </select>
              </div>
            </div>

            <div class="uk-width-1-1">
              <label class="uk-form-label" for="summary">Summary</label>
              <div class="uk-form-controls uk-margin-small-top">
                <input class="uk-input" type="text" name="summary" placeholder="Summary" minlength="3" maxlength="100" required v-model="ticket.summary" />
              </div>
            </div>

            <div class="uk-width-1-1">
              <label class="uk-form-label" for="details">Details</label>
              <div class="uk-form-controls uk-margin-small-top">
                <textarea class="uk-textarea" type="text" name="details" placeholder="Enter the details of your issue here..." rows="8" minlength="3" required v-model="ticket.details"/>
              </div>
            </div>

          </form>
        </template>

        <template v-slot:footer>
          <div class="uk-flex-left" uk-grid>
            <div class="uk-flex-last uk-width-1-1@s uk-width-1-4@m">
              <BitButton type="submit_ticket_reply" @click.native="submit_create_ticket()" color="green" v-if="!spin">Create</BitButton>
              <BitButton v-if="spin" color="green" disabled><div uk-spinner></div></BitButton>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import BitButton from '@/components/common/button.vue';
import Card from '@/components/common/card.vue';

import { mapActions, mapState } from "vuex";

import UIkit from 'uikit';

export default {
  name: 'CreateTicket',
  components: {
    BitButton,
    Card,
  },
  created() {
    this.GET_DEPARTMENTS();
    this.discard_edits();
  },
  computed: {
    ...mapState('tickets', ['departments', 'priorities'])
  },
  data() {
    return {
      spin: false,
      ticket: {
        department_id: 1,
        priority: 'low',
        summary: null,
        details: null
      }
    }
  },
  methods: {
    ...mapActions('tickets', ['GET_DEPARTMENTS', 'GET_TICKETS', 'CREATE_TICKET']),
    discard_edits() {
      this.ticket.department_id = 1;
      this.ticket.summary = null;
      this.ticket.details = null;
    },
    submit_create_ticket() {
      this.spin = true;

      this.CREATE_TICKET(this.ticket)
        .then( () => {
          this.spin = false;
          this.discard_edits();
          this.$router.push( { name: 'Tickets' } );
        }).catch( () => {
          this.spin = false;
          UIkit.modal('#CreateTicketErrorModal').show();
        })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/theme.less";


</style>
